export const zipCodes = {
  count: 10,
  zips: [
    {
      longitude: '-73.0456',
      latitude: '40.8154',
      stateName: 'New York',
      countryName: 'USA',
      countryId: 1,
      stateId: 33,
      code: '00501',
      id: 1,
    },
    {
      longitude: '-53.0456',
      latitude: '40.3154',
      stateName: 'Alaska',
      countryName: 'USA',
      countryId: 1,
      stateId: 6,
      code: '00544',
      id: 2,
    },
    {
      longitude: '-66.736735',
      latitude: '18.196747',
      stateName: 'Puerto Rico',
      countryName: 'USA',
      countryId: 1,
      stateId: 57,
      code: '00601',
      id: 3,
    },
    {
      longitude: '-67.177532',
      latitude: '18.352927',
      stateName: 'Puerto Rico',
      countryName: 'USA',
      countryId: 1,
      stateId: 57,
      code: '00602',
      id: 4,
    },
    {
      longitude: '-67.129867',
      latitude: '18.458585',
      stateName: 'Puerto Rico',
      countryName: 'USA',
      countryId: 1,
      stateId: 57,
      code: '00603',
      id: 5,
    },
    {
      longitude: '-67.147741',
      latitude: '18.488773',
      stateName: 'Puerto Rico',
      countryName: 'USA',
      countryId: 1,
      stateId: 57,
      code: '00604',
      id: 6,
    },
    {
      longitude: '-67.1538',
      latitude: '18.4289',
      stateName: 'Puerto Rico',
      countryName: 'USA',
      countryId: 1,
      stateId: 57,
      code: '00605',
      id: 7,
    },
    {
      longitude: '-66.939233',
      latitude: '18.166734',
      stateName: 'Puerto Rico',
      countryName: 'USA',
      countryId: 1,
      stateId: 57,
      code: '00606',
      id: 8,
    },
    {
      longitude: '-67.143877',
      latitude: '18.286779',
      stateName: 'Puerto Rico',
      countryName: 'USA',
      countryId: 1,
      stateId: 57,
      code: '00610',
      id: 9,
    },
    {
      longitude: '-66.9698',
      latitude: '18.2856',
      stateName: 'Puerto Rico',
      countryName: 'USA',
      countryId: 1,
      stateId: 57,
      code: '00611',
      id: 10,
    },
  ],
};
